import ReactDOM from 'react-dom';

// eslint-disable-next-line import/no-cycle
import AvailabilityWidget from './AvailabilityWidget';

const AvailabilityWidgetApp = (props) => {
  const { reservationTypeSlug, node } = props;
  return ReactDOM.createPortal(
    <>
      <AvailabilityWidget
        reservationTypeSlug={reservationTypeSlug}
        form={reservationTypeSlug}
      />
    </>,
    node
  );
};

export default AvailabilityWidgetApp;
